import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { saveReturnUrlFromSearch } from '../utils/returnUrl';

// /giris → giriş modalının açılacağı ana sayfaya yönlendirir.
// Adresteki ?returnUrl= değerini kaybetmemek için önce saklar.
const LoginRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    saveReturnUrlFromSearch(location.search);
  }, [location.search]);

  return <Navigate to="/?login=1" replace />;
};

export default LoginRedirect;
